import React, { useEffect, useState, useContext } from 'react';
import { makeStyles, useTheme } from '@mui/styles';
import PropTypes from 'prop-types';

import StyledTooltip from '../styled/tooltip';
import { GroupsContext } from '../../data/groups-service';

import {
    scaleLinear as D3scaleLinear,
    scaleOrdinal as D3scaleOrdinal,
    format as D3format,
} from 'd3';

const useStyles = makeStyles(theme => ({
    root: {
    },
    chart: {
        overflow: 'hidden',
        animation: 'expand 1.5s ease forwards',
    },
    block: {
        display: 'block',
        height: 25,
        fontSize: '.75em',
        float: 'left',
        position: 'relative',
        overflow: 'hidden',
        opacity: 1,
        transition: 'opacity, .3s ease',
        cursor: 'pointer',
    },
    value: {
        display: 'block',
        lineHeight: '1em',
        position: 'absolute',
        top: '30%',
        left: 10,
    },
}));

const SeriesCountBar = (props) => {
    const classes = useStyles();
    const theme = useTheme();

    const [data, setData] = useState([]);
    // const [width, setWidth] = useState([]);
    const { groupKeys } = useContext(GroupsContext);

    // value, size and colors hook
    useEffect(() => {
        const colorfn = D3scaleOrdinal()
            .range(theme.SeverityColors.concat(theme.ChartColors))
            .domain(groupKeys);

        const total = props.data.reduce((a, c) => (a += c.count), 0);
        // sometimes segments go over because of min 5 width
        const widthfn = D3scaleLinear()
            .range([0, props.width - 40 || 50])
            .domain([0, total || 5]);
        setData((props.data || []).map(d => ({
            ...d,
            color: colorfn(d.key),
            width: widthfn(d.count),
        })));
    }, [
        props.data,
        props.width,
        groupKeys,
        theme.ChartColors,
        theme.SeverityColors,
    ]);

    return (
        <div className={classes.graphic}>
            <div className={classes.row}>
                <div className={classes.chart}>
                    {(data || []).map(v =>
                        <StyledTooltip
                            key={v.key}
                            title={`${v.key}: ${D3format(',.0f')(v.count)}`}>
                            <span
                                key={v.key}
                                className={classes.block}
                                onClick={() => props.onClick && props.onClick(v)}
                                style={{
                                    backgroundColor: v.color,
                                    color: theme.palette.getContrastText(v.color),
                                    width: Math.max(v.width, 5),
                                    cursor: props.onClick ? 'cursor' : '',
                                }}>
                                <span className={classes.value}>
                                    {D3format(',.0f')(v.count)}
                                </span>
                            </span>
                        </StyledTooltip>
                    )}
                </div>
            </div>
        </div>
    );
};

SeriesCountBar.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        count: PropTypes.number.isRequired,
        key: PropTypes.string.isRequired,
    })).isRequired,
    width: PropTypes.number,
    label: PropTypes.string,
    onClick: PropTypes.func,
    // override max group here
    // maxGroup: PropTypes.number,
};

export default SeriesCountBar;
